import type FlagType from "owa-service/lib/contract/FlagType";
import { action } from "satcheljs";

export interface APPLY_CONVERSATION_FLAG_STATE_STORE_UPDATEActionMessage {
    conversationIds: string[];
    flagType: FlagType;
    tableViewId: string;
}
const defaultExport: (conversationIds: string[], flagType: FlagType, tableViewId: string) => APPLY_CONVERSATION_FLAG_STATE_STORE_UPDATEActionMessage = action("APPLY_CONVERSATION_FLAG_STATE_STORE_UPDATE", (conversationIds: string[], flagType: FlagType, tableViewId: string): APPLY_CONVERSATION_FLAG_STATE_STORE_UPDATEActionMessage => ({
    conversationIds,
    flagType,
    tableViewId,
}));
export default defaultExport;
